import { Link } from 'react-router-dom'
import { useApiQuery } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'

/** Equivalent of legacy `PaymentNewComponent` — the current payment/usage
 * landing page (audit §3: "current payment/usage landing page"). Legacy's
 * `/payment/old/*` stack (`PaymentComponent`) is intentionally NOT ported —
 * the shared library's payment module only implements the current-generation
 * contract (see grabbitbot-legacy-ui README, payment module docblock). */
export function PaymentHomePage() {
  // Legacy `PaymentService.getUsageStat()` called `GET /credits/usage`
  // (audit §6/§4) — that path is not in the FastAPI contract
  // (routes.json only has `/payment/credits` and `/payment/credits/{currency}`),
  // so this landing page uses the contract's own credits-overview endpoint
  // instead. See this app's README "Endpoints used not in routes.json".
  const usage = useApiQuery(() => paymentClient.searchCreditInfos(), [])

  return (
    <div>
      <h1>Payment</h1>
      <nav className="screener-nav">
        <Link to="/payment/subscriptions">Subscriptions</Link>
        <Link to="/payment/products">Products</Link>
        <Link to="/payment/usagefees">Usage fees</Link>
        <Link to="/payment/method">Payment method</Link>
        <Link to="/payment/billing">Billing address</Link>
        <Link to="/payment/credit">Credit</Link>
        <Link to="/payment/transactions">Transactions</Link>
        <Link to="/payment/invoices">Invoices</Link>
      </nav>

      <div className="screener-card">
        <h2>Usage</h2>
        {usage.loading && <p>Loading usage…</p>}
        {usage.error && <p role="alert">Could not load usage statistics.</p>}
        {usage.data != null && <pre>{JSON.stringify(usage.data, null, 2)}</pre>}
      </div>
    </div>
  )
}
